<template>
  <div class="containerTable">
    <div v-if="loginkTarget === '1'" class="remarks">
      天津监管平台资金流水完成支付24小时后进行上报会异常，线上支付获取流水号后请及时上报资金流水，转账支付请确认付款时间并及时上报资金流水！
    </div>
    <vxe-toolbar
      id="toolbarId_ca46"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="approval_search_button" @click="funcFilter"
          >查询</el-button
        >
        <!-- <el-button v-if="approval_joinBlockChain_button" @click="joinBlockChain"
          >一键上链</el-button
        >
        <el-button
          v-if="approval_internetBanking_button"
          @click="InternetBanking"
          >合并打款</el-button
        >
        <el-button
          v-if="approval_batchCashTransfer_button"
          @click="CashTransfer()"
          >转账支付</el-button
        >
        <el-button v-if="approval_paymentBank_button" @click="funcBank()"
          >银行支付</el-button
        >
        <el-button
          v-if="approval_refreshBank_button"
          @click="funcrefreshBank(false, 'pay')"
          >更新支付状态</el-button
        >
        <el-button
          v-if="approval_update_button"
          @click="funcrefreshBank(false, 'payToDriverResult')"
          >更新状态</el-button
        >
        <el-button
          v-if="approval_queryCreditBalance_button"
          @click="queryCreditBalance"
          >凭证可用余额查询</el-button
        >
        <el-button v-if="Approval_payOnlineBatch_button" @click="funcPayOnline"
          >在线支付</el-button
        >
        <el-button
          v-if="approval_billingApplication_button"
          @click="getApplicationEvent()"
        >
          批量开票申请
        </el-button>
        <el-button
          v-if="getLimit('approval_export_button')"
          @click="funcExport()"
          >导出</el-button
        > -->
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{ highlight: true, checkMethod: checCheckboxkMethod }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isReceiptReturn"
          :formatter="formatterReceiptStatus"
          title="纸质回单状态"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isReceiptReturn"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in receiptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin && isShowTxStatus == 1">
        <vxe-table-column
          field="txStatus"
          title="上链状态"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'txStatus')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.txStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.txStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!--<vxe-table-column>
        <vxe-table-column  field="proofResultMsg"  title="上链信息" min-width="150"  sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.proofResultMsg" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByPhone"
            placeholder="请输入托运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="托运人"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payStatus"
          title="支付状态"
          min-width="190"
          sortable
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payStatus')
          "
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.payStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payFailReasons"
          title="失败原因"
          min-width="190"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payFailReasons"
            placeholder="请输入失败原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isTransfer"
          title="是否调单"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.isTransfer > 0 ? "是" : "否" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isTransferSearch"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isTransferSearchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入运输要求"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadPlace"
          title="实际操作装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadPlace"
            placeholder="请输入实际操作装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadPlace"
          title="实际操作卸货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.unloadPlace"
            placeholder="请输入实际操作卸货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="里程数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="银企收款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入收款人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="jinchangTaxPlatform">
        <vxe-table-column
          field="billingConfirmationStatus"
          title="开票确认"
          :formatter="formatterBillingConfirmationStatus"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.billingConfirmationStatus"
            clearable
            placeholder="请选择开票确认状态"
          >
            <el-option
              v-for="item in billingConfirmationStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="接单数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸货数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="wastage"
          title="货物损耗"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.wastageStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.wastageEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settlementWeight"
          title="结算吨位"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.settlementWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.settlementWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxPrice"
          title="托运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="taxFee"
          title="托运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="payTaxAmount"
          title="托运人预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payTaxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payTaxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人应付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人实付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualCash"
          title="托运人实付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipperDeliveryFee"
          title="托运人合计付款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="taxPayFee"
          title="服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryFeeDeserved"
          title="实际承运人预估运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeeDeservedStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeeDeservedEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="platformPrepayment"
          title="平台预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.platformPrepaymentStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.platformPrepaymentEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人应收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualFreight"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualCash"
          title="实际承运人实收现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="deliveryCashFee"
          title="实际承运人合计收款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryCashFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryCashFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="extraFee"
          title="其他费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.extraFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.extraFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="abnormalFee"
          title="异常费用(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.abnormalFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.abnormalFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="payOil"
          title="平台预付油点(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="allotOil"
          title="已分配油费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allotOilStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allotOilEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="接单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="settleTime"
          title="核算时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.settleTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'settleTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="270" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="approval_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!-- <el-tooltip
            v-if="
              approval_allocateOil_button &&
                scope.row.proofStatus == 0 &&
                (scope.row.payStatus == 0 || scope.row.payStatus == 3)
            "
            class="item"
            effect="dark"
            content="分配油点"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="(code) => showModel(scope.row, 'AllocateOil')"
            >
              <i class="el-icon-odometer" />
            </vxe-button>
          </el-tooltip> -->
          <!-- 在线支付 -->
          <!-- <el-tooltip
            v-if="
              approval_payOnline_button &&
                scope.row.proofStatus == 0 &&
                (scope.row.payStatus == 0 || scope.row.payStatus == 3)
            "
            class="item"
            effect="dark"
            content="在线支付"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row, 'PayOnline')"
            >
              <i class="el-icon-shopping-cart-2" />
            </vxe-button>
          </el-tooltip> -->
          <el-tooltip
            v-if="
              approval_cashMoney_button &&
                scope.row.proofStatus == 0 &&
                (scope.row.payStatus == 0 || scope.row.payStatus == 3)
            "
            class="item"
            effect="dark"
            content="余额支付"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => showModel(scope.row, 'CashMoney')"
            >
              <i class="el-icon-shopping-cart-2" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              creditPayTag &&
                approval_creditPay_button &&
                scope.row.proofStatus == 0 &&
                scope.row.txStatus == 4
            "
            class="item"
            effect="dark"
            content="凭证支付"
            placement="top"
          >
            <vxe-button type="text" @click="creditPay(scope.row)">
              <i class="el-icon-price-tag" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              creditPayTag &&
                approval_creditPay_button &&
                scope.row.proofStatus == 1
            "
            class="item"
            effect="dark"
            content="刷新凭证状态"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="creditPayReload(scope.row.proofCode)"
            >
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              creditPayTag &&
                approval_creditPay_button &&
                scope.row.proofStatus == 2
            "
            class="item"
            effect="dark"
            content="重新凭证支付"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="creditPayAgain(scope.row.proofCode)"
            >
              <i class="el-icon-price-tag" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              creditPayTag &&
                approval_creditPay_button &&
                scope.row.proofStatus == 2
            "
            class="item"
            effect="dark"
            content="凭证支付撤回"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="creditPayRollBack(scope.row.proofCode)"
            >
              <i class="el-icon-back" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              creditPayTag &&
                approval_creditPay_button &&
                scope.row.proofStatus == 1 &&
                scope.row.proofPublishUrl
            "
            class="item"
            effect="dark"
            content="发行凭证"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="publishProof(scope.row.proofPublishUrl)"
            >
              <i class="el-icon-s-unfold" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              approval_cashTransfer_button &&
                scope.row.proofStatus == 0 &&
                (scope.row.payStatus == 0 ||
                  scope.row.payStatus == 3 ||
                  scope.row.returnPayStatus === 1)
            "
            class="item"
            effect="dark"
            content="转账支付"
            placement="top"
          >
            <vxe-button type="text" @click="CashTransfer(scope.row)">
              <i class="el-icon-coin" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              approval_paymentBank_button &&
                scope.row.proofStatus == 0 &&
                (scope.row.payStatus == 0 || scope.row.payStatus == 3)
            "
            class="item"
            effect="dark"
            content="银行支付"
            placement="top"
          >
            <vxe-button type="text" @click="funcBank(scope.row)">
              <i class="el-icon-bank-card" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              approval_refreshBank_button &&
                scope.row.proofStatus == 0 &&
                scope.row.payStatus == 1
            "
            class="item"
            effect="dark"
            content="更新打款状态"
            placement="top"
          >
            <vxe-button type="text" @click="funcrefreshBank(scope.row, 'pay')">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.bankCardCode"
            class="item"
            effect="dark"
            content="修改银行卡信息"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcBankCardEdit(scope.row.bankCardCode)"
            >
              <i class="el-icon-bank-card" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              approval_update_button &&
                scope.row.proofStatus == 0 &&
                scope.row.payStatus == 1
            "
            class="item"
            effect="dark"
            content="更新状态"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcrefreshBank(scope.row, 'payToDriverResult')"
            >
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <!-- <el-tooltip
            v-if="
              approval_reject_button &&
                isAdmin &&
                scope.row.proofStatus == 0 &&
                (scope.row.payStatus == 0 || scope.row.payStatus == 3)
            "
            class="item"
            effect="dark"
            content="驳回"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="
                funcReject(scope.row.code, scope.row.billingConfirmationStatus)
              "
            >
              <i class="el-icon-back" />
            </vxe-button>
          </el-tooltip> -->
          <!--   <el-tooltip
            v-if="
              approval_billingApplication_button &&
                (scope.row.billingConfirmationStatus == 0 ||
                  scope.row.billingConfirmationStatus == 3)
            "
            class="item"
            effect="dark"
            content="开票申请"
            placement="top"
          >
            <vxe-button type="text" @click="billingApplication(scope.row.code)">
              <i class="el-icon-document-copy" />
            </vxe-button>
          </el-tooltip> -->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="ModelAllocateOil"
      title="分配油点"
      width="800"
      height="80%"
      resize
    >
      <AllocateOil ref="AllocateOilRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="ModelCashMoney"
      title="余额支付"
      width="800"
      height="80%"
      resize
      @close="close"
    >
      <CashMoney ref="CashMoneyRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="ModelBusiness"
      title="合并支付"
      width="900"
      height="80%"
      resize
    >
      <netBusinessMain ref="BusinessRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="excessListFlag"
      title="超额提示"
      width="860"
      height="420"
      resize
    >
      <excessList ref="excessList" @goOnPay="goOnPay" @cancelPay="cancelPay" />
    </vxe-modal>
    <cash-transfer
      ref="cashTransfer"
      :parent-data="cashParentData"
      @onSuccess="findList"
    />
    <vxe-modal
      v-model="ModelCreditPay"
      title="凭证支付"
      width="800"
      height="80%"
      resize
      @close="close"
    >
      <CreditPay ref="CreditPayRef" @hideModel="hideModel" />
    </vxe-modal>
    <paymentBank
      ref="paymentBank"
      :parent-data="bankParentData"
      @onSuccess="findList"
    />
    <vxe-modal
      v-model="details"
      title="查看订单详情"
      width="1000"
      height="600"
      resize
    >
      <accounting ref="detailRef" />
    </vxe-modal>
    <!-- 在线支付 -->
    <vxe-modal
      v-model="ModelPayOnline"
      title="在线支付"
      width="800"
      height="80%"
      resize
      :destroy-on-close="true"
      @close="closeDialog"
    >
      <payOnline ref="PayOnlineRef" @hideModel="hideModel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-modal
      v-model="bankCardEditFlag"
      title="银行卡编辑"
      width="800"
      height="780"
      resize
    >
      <bankCardEdit
        ref="bankCardEditRef"
        :payment-type="paymentType"
        @fatherEditMethod="bankCardFatherEdit"
        @fatherCancelMethod="bankCardFatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="ModelPayConfirm"
      title="开票申请未通过"
      width="80%"
      height="75%"
      resize
      remember
    >
      <billingConfirm
        ref="billingConfirmRef"
        @onHideConfirm="hideBillingConfirm"
        @onPayment="toPayment"
      />
    </vxe-modal>
  </div>
</template>
<script>
import request from "@/utils/request";
import bankCardEdit from "@/views/basicInfo/bankCard/components/bankCardEdit.vue";
import AllocateOil from "./components/allocateOil.vue";
import accounting from "@/components/WaybillDetails";
import CashMoney from "./components/cashMoney.vue";
import netBusinessMain from "./components/netBusinessMain.vue";
import excessList from "./components/excessList.vue";
import cashTransfer from "./components/CashTransfer.vue";
import CreditPay from "./components/creditPay.vue";
import paymentBank from "./components/paymentBank.vue";
import payOnline from "./components/payOnline.vue";
import billingConfirm from "./components/billingConfirm.vue";
import { getGoodsTypeDict } from "@/api/shipment";
import {
  orderDetailList,
  financeRejectAndRefund,
  payverifyPayee,
  centralQueryPaymentResult,
  isOpenMaYi,
  queryPayToDriverResult,
  billingApplication,
  verifyBillingConfirmationStatus
} from "@/api/transport";
import { getMayiCreditBalance } from "@/api/InternetBanking";
import { getLimit } from "@/utils/getLimit.js";
export default {
  components: {
    bankCardEdit,
    AllocateOil,
    CashMoney,
    netBusinessMain,
    excessList,
    accounting,
    cashTransfer,
    paymentBank,
    CreditPay,
    payOnline,
    billingConfirm
  },
  data() {
    return {
      exportObj: {
        exportUrl: "ntocc-tms-api/orderDetail/exportDetailApproval", //导出接口
        name: "财务打款"
      },
      bankCardEditFlag: false,
      loading: false,
      ModelAllocateOil: false,
      ModelCashMoney: false,
      ModelBusiness: false,
      ModelCreditPay: false,
      excessListFlag: false,
      ModelPayOnline: false,
      details: false,
      openMaYiBlockChain: false, //是否数据上链
      approval_search_button: false, //查询
      approval_internetBanking_button: false, //合并打款
      approval_joinBlockChain_button: false, //一键上链
      approval_batchCashTransfer_button: false, //转账支付
      approval_queryCreditBalance_button: false, //凭证可用余额查询
      approval_detail_button: false, //详情
      approval_allocateOil_button: false, //分配油点
      approval_cashMoney_button: false, //余额支付
      approval_cashTransfer_button: false, //转账支付
      approval_paymentBank_button: false, //银行支付
      approval_reject_button: false, //驳回
      approval_creditPay_button: false, // 凭证支付
      approval_refreshBank_button: false, // 更新打款状态
      approval_update_button: false, // 更新状态
      approval_payOnline_button: false, // 在线支付
      Approval_payOnlineBatch_button: false, // 在线支付批量
      approval_billingApplication_button: false, // 开票申请
      tableData: [],
      parentData: {},
      cashParentData: {},
      bankParentData: {},
      areaOptions: this.$store.state.components.areaOptions,
      goodsTypeList: [],
      consigneeAreaList: [],
      consignorAreaList: [],
      partyType: this.$store.getters.party.partyType,
      listQuery: {
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        gmtCreatedRange: "",
        orderGmtCreatedRange: "",
        settleTimeRange: "",
        gmtModifiedRange: "",
        // status: 4,
        // applyStatus: 1,
        paymentStatus: 1,
        reportMark: "",
        vehicleLicense: "",
        orderCode: "",
        driverName: "",
        teamName: "",
        driverPhone: "",
        loadWeight: "",
        unloadWeight: "",
        taxPrice: "",
        price: "",
        allotOil: "",
        allotAmount: "",
        distance: "",
        deliveryFeeDeserved: "",
        deliveryCashFee: "",
        deliveryFeePractical: "",
        payOil: "",
        payAmount: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        fillTimeStart: "",
        fillTimeEnd: "",
        lastLoadingTimeStart: "",
        lastLoadingTimeEnd: "",
        lastUnloadingTimeStart: "",
        lastUnloadingTimeEnd: "",
        gmtModifiedStart: "",
        gmtModifiedEnd: "",
        modifiedByName: "",
        mainOrderNumber: "",
        coalType: "",
        shipperSubdivisionCode: "",
        consigneeSubdivisionCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        mybankPrepayCodeIsNull: "0"
      },
      isTransferSearchOptions: [
        { value: 0, label: "否" },
        { value: 1, label: "是" }
      ],
      receiptOptions: [
        {
          value: "0",
          label: "未收取"
        },
        {
          value: "1",
          label: "已收取"
        },
        {
          value: "2",
          label: "已签收"
        }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      Waybillobject: {
        amount: "",
        orderDetailCode: ""
      },
      payway: "",
      codes: "",
      sumObject: {},
      // 机构列表
      branchList: this.$store.state.components.branchList,
      // 是否admin
      isAdmin: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      // 是否开启凭证支付
      creditPayTag: false,
      isShowTxStatus: "",
      paymentType: "",
      billingConfirmationStatusOptions: [
        { value: 0, label: "未申请" },
        { value: 1, label: "确认中" },
        { value: 2, label: "已通过" },
        { value: 3, label: "未通过" }
      ],
      jinchangTaxPlatform: false,
      ModelPayConfirm: false,
      loginkTarget: "0"
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.parentData.txStatusOptions = [
      { label: "未上链", value: 0 },
      { label: "货源单上链", value: 1 },
      { label: "运单创建", value: 2 },
      { label: "运单启运", value: 3 },
      { label: "已上链", value: 4 },
      { label: "运单支付单创建", value: 5 },
      { label: "运单完成", value: 6 },
      { label: "运单关闭", value: 7 }
    ];
    this.parentData.payStatusOptions = [
      { label: "未支付", value: 0 },
      { label: "处理中", value: 1 },
      { label: "支付成功", value: 2 },
      { label: "支付失败", value: 3 }
    ];
    // 货物类型
    getGoodsTypeDict({ parentCode: "goodsBigType" }).then(response => {
      this.goodsTypeList = response.data.records;
    });
    this.findList();
    //this.findBranchList();
    this.getMaYiOpen();

    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    if (dataBranch.partyGroupConfigCacheMap.payment_type) {
      this.paymentType =
        dataBranch.partyGroupConfigCacheMap.payment_type.configValue;
    }
    this.openMaYiBlockChain = dataBranch.partyGroupConfigCacheMap
      .MaYiBlockChainConfig_useMaYiCredit
      ? dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiCredit
          .configValue == 1
      : false;
    this.loginkTarget = dataBranch.partyGroupConfigCacheMap
      .loginkTarget_reportProvince
      ? dataBranch.partyGroupConfigCacheMap.loginkTarget_reportProvince
          .configValue
      : 0;
    this.approval_search_button = getLimit("approval_search_button");
    this.approval_refreshBank_button = getLimit("approval_refreshBank_button");
    this.approval_internetBanking_button = getLimit(
      "approval_internetBanking_button"
    );
    this.approval_joinBlockChain_button =
      getLimit("approval_joinBlockChain_button") && this.openMaYiBlockChain;
    this.approval_batchCashTransfer_button = getLimit(
      "approval_batchCashTransfer_button"
    );
    this.approval_queryCreditBalance_button =
      getLimit("approval_queryCreditBalance_button") && this.openMaYiBlockChain;
    this.approval_detail_button = getLimit("approval_detail_button");
    this.approval_allocateOil_button = getLimit("approval_allocateOil_button");
    this.approval_cashMoney_button = getLimit("approval_cashMoney_button");
    this.approval_cashTransfer_button = getLimit(
      "approval_cashTransfer_button"
    );
    this.approval_paymentBank_button = getLimit("approval_paymentBank_button");
    this.approval_reject_button = getLimit("approval_reject_button");
    this.approval_creditPay_button = getLimit("approval_creditPay_button");
    this.approval_update_button = getLimit("approval_update_button");
    this.approval_payOnline_button = getLimit("approval_payOnline_button");
    this.Approval_payOnlineBatch_button = getLimit(
      "Approval_payOnlineBatch_button"
    );
    this.approval_billingApplication_button = getLimit(
      "approval_billingApplication_button"
    );
    this.jinchangTaxPlatform =
      this.$store.state.user.party.taxTargetPlatform === "2";
    return request({
      url: "/ntocc-tms-api/maYiCreditFlow/useMayiCredit",
      method: "post"
    }).then(res => {
      // console.log(res);
      this.creditPayTag = res.data == "1" ? true : false;
    });
  },
  methods: {
    // add by JiaYK start 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    getMaYiOpen() {
      isOpenMaYi({ branchCode: this.$store.state.user.party.branchCode }).then(
        res => {
          this.isShowTxStatus = res.data;
        }
      );
    },
    // add by JiaYK end 2021/10/23 13:19 区块链是否开启显示隐藏上链字段
    closeDialog() {
      this.$refs.PayOnlineRef.selectItem();
    },
    funcBankCardEdit(code) {
      this.$refs.bankCardEditRef.getInfo(code);
      this.bankCardEditFlag = true;
    },
    bankCardFatherEdit() {
      this.bankCardEditFlag = false;
    },
    // 公共取消
    bankCardFatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.bankCardEditFlag = false;
          break;
      }
    },
    // 重载凭证状态
    creditPayReload(code) {
      if (code) {
        this.loading = true;
        request({
          url: "/ntocc-tms-api/maYiCreditFlow/reloadCreditIssue",
          method: "post",
          params: { code }
        })
          .then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 重新凭证支付
    creditPayAgain(code) {
      if (code) {
        this.loading = true;
        request({
          url: "/ntocc-tms-api/creditProof/apply/again",
          method: "get",
          params: { code }
        })
          .then(response => {
            this.$message({ message: response.msg, type: "success" });
            window.open(response.data);
            this.findList();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 撤销凭证打款
    creditPayRollBack(code) {
      if (code) {
        this.loading = true;
        request({
          url: "/ntocc-tms-api/maYiCreditFlow/rollBackCreditIssue",
          method: "post",
          params: { code }
        })
          .then(response => {
            this.findList();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 发行凭证
    publishProof(publishUrl) {
      window.open(publishUrl);
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        orderDetailList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.price = item.price + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
            item.loadQuantity = item.loadQuantity + item.coalUnitName;
            item.unloadQuantity = item.unloadQuantity + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    //状态翻译
    formatterReceiptStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "未收取";
        case "1":
          return "已收取";
        case "2":
          return "已签收";
        default:
          break;
      }
    },
    handleClick(c) {
      this.details = true;
      this.$refs.detailRef.Getdetails(c);
    },
    // 转账支付
    CashTransfer(item) {
      console.log(item);
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要打款的项");
        return false;
      } else if (checkedRowArray.length > 200) {
        this.$message.warning("批量处理最多200条数据");
        return false;
      }
      let payeeCode = checkedRowArray[0].payeeCode;
      let branchCode = checkedRowArray[0].branchCode;
      let totalAmount = 0; //付款金额
      let taxPayFee = 0; // 服务费
      let codes = [];
      for (let subItem of checkedRowArray) {
        if (subItem.payeeCode != payeeCode) {
          this.$message.warning("请选择同一收款人");
          return false;
        }
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构");
          return false;
        }
        // if (subItem.payStatus != 0 && subItem.payStatus != 3) {
        //   this.$message.warning("当前支付状态不能支付");
        //   return false;
        // }

        totalAmount += subItem.driverActualCash * 100; //修改实际承运人金额
        taxPayFee += subItem.taxPayFee * 100;
        codes.push(subItem.code);
      }
      this.cashParentData.payeeCode = payeeCode;
      this.cashParentData.codes = codes;
      this.cashParentData.branchCode = branchCode;
      this.cashParentData.totalAmount = (totalAmount / 100).toFixed(2);
      this.cashParentData.taxPayFee = (taxPayFee / 100).toFixed(2);
      let formData = {
        orderDetailCode: codes[0],
        amount: (totalAmount / 100).toFixed(2)
      };
      if (this.jinchangTaxPlatform) {
        if (
          checkedRowArray.length === 1 &&
          checkedRowArray[0].billingConfirmationStatus !== 2
        ) {
          this.$confirm(
            "此运单实际承运人开票确认不为已通过状态，影响税务开票，是否继续打款？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(_ => {
            this.verifyPayee2(formData);
          });
        } else if (checkedRowArray.length > 1) {
          let detailCodes = codes.join(",");
          verifyBillingConfirmationStatus({ detailCodes }).then(response => {
            if (response.data.length > 0) {
              this.ModelPayConfirm = true;
              this.$nextTick(() => {
                this.$refs.billingConfirmRef.verifyBillingConfirmationStatusInfo(
                  codes.join(","),
                  formData,
                  response.data,
                  ""
                );
              });
            } else {
              this.verifyPayee2(formData);
            }
          });
        } else {
          this.verifyPayee2(formData);
        }
      } else {
        this.verifyPayee2(formData);
      }
    },
    async verifyPayee2(formData) {
      let response = await payverifyPayee(formData);
      if (response.data) {
        this.$refs.cashTransfer.show();
      } else {
        this.$confirm("预付将使本账户汇款超额，是否继续预付操作？").then(_ => {
          this.$refs.cashTransfer.show();
        });
      }
    },
    // 银行支付
    funcBank(item) {
      let ismore = !item;
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要打款的项");
        return false;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return false;
      }
      let branchCode = checkedRowArray[0].branchCode;
      let payeeCode = checkedRowArray[0].payeeCode;
      let totalAmount = 0;
      let taxPayFee = 0;
      let deliveryCashFee = 0;
      let allotAmount = 0;
      let allotOil = 0;
      let codes = [];
      for (let subItem of checkedRowArray) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构");
          return false;
        }
        if (subItem.payStatus != 0 && subItem.payStatus != 3) {
          this.$message.warning("当前支付状态不能支付");
          return false;
        }
        if (subItem.payeeCode != payeeCode) {
          this.$message.warning("请选择同一收款人");
          return false;
        }

        totalAmount +=
          subItem.deliveryCashFee * 100 -
          subItem.allotAmount * 100 -
          subItem.allotOil * 100;
        deliveryCashFee += subItem.deliveryCashFee;
        taxPayFee += subItem.taxPayFee;
        allotAmount += subItem.allotAmount;
        allotOil += subItem.allotOil;
        codes.push(subItem.code);
      }
      this.bankParentData.payeeCode = payeeCode;
      this.bankParentData.orderDetailNumber = checkedRowArray[0].orderCode;
      this.bankParentData.branchCode = branchCode;
      this.bankParentData.codes = codes.join(",");
      this.bankParentData.deliveryCashFee = deliveryCashFee.toFixed(2);
      this.bankParentData.allotAmount = allotAmount.toFixed(2);
      this.bankParentData.allotOil = allotOil.toFixed(2);
      this.bankParentData.totalAmount = (totalAmount / 100).toFixed(2);
      this.bankParentData.taxPayFee = (taxPayFee / 100).toFixed(2);
      if (this.jinchangTaxPlatform) {
        if (
          checkedRowArray.length === 1 &&
          checkedRowArray[0].billingConfirmationStatus !== 2
        ) {
          this.$confirm(
            "此运单实际承运人开票确认不为已通过状态，影响税务开票，是否继续打款？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(_ => {
            this.$refs.paymentBank.show(ismore);
          });
        } else if (checkedRowArray.length > 1) {
          let detailCodes = codes.join(",");
          verifyBillingConfirmationStatus({ detailCodes }).then(response => {
            if (response.data.length > 0) {
              this.ModelPayConfirm = true;
              this.$nextTick(() => {
                this.$refs.billingConfirmRef.verifyBillingConfirmationStatusInfo(
                  codes.join(","),
                  null,
                  response.data,
                  ""
                );
              });
            } else {
              this.$refs.paymentBank.show(ismore);
            }
          });
        } else {
          this.$refs.paymentBank.show(ismore);
        }
      } else {
        this.$refs.paymentBank.show(ismore);
      }
    },
    // 更新集中支付打款状态
    // 更新集中支付打款状态  更新状态
    async funcrefreshBank(item, flag) {
      let updataApiFun =
        flag == "payToDriverResult"
          ? queryPayToDriverResult
          : centralQueryPaymentResult;
      let checkedRowArray = item
        ? [item]
        : this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要更新的项");
        return false;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return false;
      }
      let branchCode = checkedRowArray[0].branchCode;
      let codes = [];
      for (let subItem of checkedRowArray) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构");
          return false;
        }
        if (subItem.payStatus != 1) {
          this.$message.warning("当前支付状态无需更新");
          return false;
        }
        codes.push(subItem.code);
      }
      codes = codes.join(",");
      const rLoading = this.openLoading();
      if (codes) {
        let response = await updataApiFun({ codes });
        rLoading.close();
        this.$message.success(response.msg);
      } else {
        this.$message.success({
          type: "warning",
          message: "当前支付状态无需更新"
        });
      }
      this.findList();
    },
    joinBlockChain() {
      const rLoading = this.openLoading();
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      let codes = checkedRowArray.map(item => item.code).join(",");
      request({
        url: `/ntocc-tms-api/maYiCreditFlow/joinBlockChain`,
        method: "get",
        params: { codes }
      }).then(response => {
        rLoading.close();
        if (response.status == 0) {
          this.$message.success("运单上链中,请稍后查看运单上链状态！");
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    // 合并打款
    InternetBanking() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({ message: "请选择需要打款的项", type: "warning" });
        return false;
      }
      if (checkedRowArray.length > 20) {
        this.$message({ message: "合并处理最多20条数据", type: "warning" });
        return false;
      }

      let branchCode = checkedRowArray[0].branchCode;
      for (let item of checkedRowArray) {
        if (item.branchCode != branchCode) {
          this.$message.warning("请选择同一机构的运单");
          return false;
        }
        if (item.payStatus != 0 && item.payStatus != 3) {
          this.$message.warning("当前支付状态不能支付");
          return false;
        }
      }

      let codes = checkedRowArray.map(item => item.code).join(",");
      this.codes = codes;
      this.verifyPayee(codes, 1);
    },
    verifyPayee(codes, payway) {
      this.payway = payway;
      const rLoading = this.openLoading();
      this.$refs.xTable.clearCheckboxRow();
      request({
        url: `/ntocc-tms-api/mybankPrepay/verifyPayee`,
        method: "get",
        params: { codes }
      }).then(response => {
        rLoading.close();
        const list = response.data;
        if (list && list.length > 0) {
          this.excessListFlag = true;
          this.$refs.excessList.init(list);
        } else {
          this.mergeRemit();
        }
      });
    },
    mergeRemit() {
      this.ModelBusiness = true;
      this.$refs.BusinessRef.init(this.codes);
    },
    goOnPay() {
      this.excessListFlag = false;
      this.mergeRemit();
    },
    cancelPay() {
      this.excessListFlag = false;
    },
    close() {
      this.$refs.CashMoneyRef.close();
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    // 装货/收获地址
    changeAreaList(value, prefix) {
      if (value.length > 0) {
        this.listQuery[`${prefix}SubdivisionCode`] = value[2];
      } else {
        this.listQuery[`${prefix}SubdivisionCode`] = "";
      }
    },
    // 类型
    handleChangeCoalType(value) {
      if (value.length > 0) {
        var newValue = value.slice(0);
        this.listQuery.coalType = newValue.pop();
      } else {
        this.listQuery.coalType = "";
      }
    },
    // 分配油点/现金打款
    showModel(row, prefix) {
      if (
        this.jinchangTaxPlatform &&
        prefix === "AllocateOil" &&
        (row.billingConfirmationStatus === 2 ||
          row.billingConfirmationStatus === 1)
      ) {
        this.$confirm(
          "油点支付会造成开票确认刷新，需重新开票确认，是否继续油点支付？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(_ => {
          this[`Model${prefix}`] = true;
          this.$nextTick(() => {
            this.$refs[`${prefix}Ref`].getInfo(row);
          });
        });
      } else if (
        this.jinchangTaxPlatform &&
        prefix === "PayOnline" &&
        row.billingConfirmationStatus !== 2
      ) {
        this.$confirm(
          "此运单实际承运人开票确认不为已通过状态，影响税务开票，是否继续打款？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(_ => {
          this[`Model${prefix}`] = true;
          this.$nextTick(() => {
            this.$refs[`${prefix}Ref`].getInfo(row);
          });
        });
      } else {
        this[`Model${prefix}`] = true;
        this.$nextTick(() => {
          this.$refs[`${prefix}Ref`].getInfo(row);
        });
      }
    },
    hideModel(url) {
      this.ModelAllocateOil = false;
      this.ModelCashMoney = false;
      this.ModelBusiness = false;
      this.ModelCreditPay = false;
      this.ModelPayOnline = false;
      this.findList();
      if (url) {
        window.open(url);
      }
    },
    funcReject(code, billingConfirmationStatus) {
      if (
        this.jinchangTaxPlatform &&
        (billingConfirmationStatus === 2 || billingConfirmationStatus === 1)
      ) {
        this.$confirm(
          "驳回会造成开票确认刷新，需重新开票确认，是否继续驳回？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(_ => {
          const rLoading = this.openLoading();
          financeRejectAndRefund({ code }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        });
      } else {
        this.$confirm("确认驳回？").then(_ => {
          const rLoading = this.openLoading();
          financeRejectAndRefund({ code }).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        });
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "shipmentActualFreight",
              "payTaxAmount",
              "platformPrepayment",
              "driverActualFreight",
              "driverActualCash",
              "shipmentActualCash",
              "shipmentDeliveryFeePractical",
              "extraFee",
              "abnormalFee"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "allotOil") {
            return this.sumObject.allotOil;
          }
          if (column.property === "allotAmount") {
            return this.sumObject.allotAmount;
          }
          if (column.property === "payOil") {
            return this.sumObject.payOil;
          }
          if (column.property === "payAmount") {
            return this.sumObject.payAmount;
          }
          if (column.property === "weight") {
            return (
              (this.sumObject.ton || 0) +
              "吨//" +
              (this.sumObject.cubicMeter || 0) +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              (this.sumObject.loadQuantityTon || 0) +
              "吨//" +
              (this.sumObject.loadQuantityCubicMeter || 0) +
              "方//" +
              (this.sumObject.loadQuantityPieces || 0) +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              (this.sumObject.unloadQuantityTon || 0) +
              "吨//" +
              (this.sumObject.unloadQuantityCubicMeter || 0) +
              "方//" +
              (this.sumObject.unloadQuantityPieces || 0) +
              "件"
            );
          }
          // 货物损耗
          if (column.property === "wastage") {
            return (
              (this.sumObject.wastageTon || 0) +
              "吨//" +
              (this.sumObject.wastageCubicMeter || 0) +
              "方//" +
              (this.sumObject.wastagePieces || 0) +
              "件"
            );
          }
          // 最高价
          if (column.property === "maxPrice") {
            return (
              (this.sumObject.maxPriceTon || 0) +
              "吨//" +
              (this.sumObject.maxPriceCubicMeter || 0) +
              "方//" +
              (this.sumObject.maxPricePieces || 0) +
              "件"
            );
          }
          // 托运人成交单价
          if (column.property === "taxPrice") {
            return (
              (this.sumObject.taxPriceTon || 0) +
              "吨//" +
              (this.sumObjecttaxPriceCubicMeter || 0) +
              "方//" +
              (this.sumObject.taxPricePieces || 0) +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    },
    creditPay(row) {
      const rLoading = this.openLoading();
      // 凭证支付判断
      let code = row.code;
      getMayiCreditBalance({ orderDetailCodes: code }).then(response => {
        rLoading.close();
        let data = response.data;
        // this.$message({ message: response.msg, type: "success" });
        if (data.whetherMeets) {
          // 满足
          let item = {
            orderDetailCodes: code,
            freight: response.data.freight,
            deliveryCashFee: response.data.deliveryCashFee,
            allotAmount: response.data.allotAmount,
            allotOil: response.data.allotOil
          };
          this.$refs.CreditPayRef.getInfo(item);
          this.ModelCreditPay = true;
        } else {
          this.$message({ message: "余额不足，无法支付", type: "warning" });
        }
      });
    },
    queryCreditBalance() {
      // 获取当前地址
      let currentUrl = window.location.href;
      return request({
        url: "/ntocc-tms-api/maYiCreditFlow/getIssueDetailUrl",
        method: "post",
        params: {
          redirectUrl: currentUrl
        }
      }).then(response => {
        if (response.status == 0) {
          let redirectUrl = response.data;
          window.open(redirectUrl, "_blank");
        } else {
          this.$message({ message: response.msg, type: "info" });
        }
      });
    },
    checCheckboxkMethod({ row }) {
      return row.proofStatus == 0;
    },
    //批量-在线支付		迁入分支  angang_youqifu/v2.3
    funcPayOnline() {
      let checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      // checkedRowArray = checkedRowArray.filter((item) => item.payStatus !== 1);
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message.warning("请选择需要打款的项或者您选择的订单已经在处理中");
        return false;
      } else if (checkedRowArray.length > 20) {
        this.$message.warning("批量处理最多20条数据");
        return false;
      }
      let branchCode = checkedRowArray[0].branchCode;
      let totalAmount = 0;
      let orderDetailCode = [];
      for (let subItem of checkedRowArray) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构运单支付");
          return false;
        }
        // console.log("subItem.payStatus", subItem.payStatus);

        if (
          (subItem.payStatus == 0 &&
            subItem.payStatus == 1 &&
            subItem.payStatus == 3) ||
          (subItem.payStatus == 1 && subItem.payStatus == 3) ||
          subItem.payStatus == 1
        ) {
          this.$message.warning("当前支付状态不能支付");
          return;
        }

        totalAmount +=
          subItem.deliveryCashFee * 100 -
          subItem.allotAmount * 100 -
          subItem.allotOil * 100;
        // console.log("totalAmount1", totalAmount);
        orderDetailCode.push(subItem.code);
      }
      // console.log("orderDetailCode", orderDetailCode);
      let payAll = 1;
      let item = {
        orderDetailCode: orderDetailCode,
        amount: (totalAmount / 100).toFixed(2),
        branchCode: branchCode
      };
      if (this.jinchangTaxPlatform) {
        if (
          checkedRowArray.length === 1 &&
          checkedRowArray[0].billingConfirmationStatus !== 2
        ) {
          this.$confirm(
            "此运单实际承运人开票确认不为已通过状态，影响税务开票，是否继续打款？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          ).then(_ => {
            this.ModelPayOnline = true;
            this.$nextTick(() => {
              this.$refs.PayOnlineRef.getShow(payAll, item);
            });
          });
        } else {
          let detailCodes = orderDetailCode.join(",");
          verifyBillingConfirmationStatus({ detailCodes }).then(response => {
            if (response.data.length > 0) {
              this.ModelPayConfirm = true;
              this.$nextTick(() => {
                this.$refs.billingConfirmRef.verifyBillingConfirmationStatusInfo(
                  detailCodes,
                  null,
                  response.data,
                  item
                );
              });
            } else {
              this.ModelPayOnline = true;
              this.$nextTick(() => {
                this.$refs.PayOnlineRef.getShow(payAll, item);
              });
            }
          });
        }
      } else {
        this.ModelPayOnline = true;
        this.$nextTick(() => {
          this.$refs.PayOnlineRef.getShow(payAll, item);
        });
      }
    },
    // 取消状态翻译
    formatterBillingConfirmationStatus({ cellValue }) {
      const item = this.billingConfirmationStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    getApplicationEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      }
      const arrcarcode = selectRecords.map(item => {
        return item.code;
      });
      let branchCode = selectRecords[0].branchCode;
      for (let subItem of selectRecords) {
        if (subItem.branchCode != branchCode) {
          this.$message.warning("请选择同一机构运单");
          return false;
        }
        if (
          subItem.billingConfirmationStatus == 1 ||
          subItem.billingConfirmationStatus == 2
        ) {
          this.$message.warning("请勿选择确认中或已通过状态运单");
          return;
        }
      }
      let codes = arrcarcode.join(",");
      this.billingApplication(codes);
    },
    billingApplication(codes) {
      this.$confirm("确认开票申请？").then(_ => {
        const rLoading = this.openLoading();
        billingApplication({ codes }).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    hideBillingConfirm() {
      this.ModelPayConfirm = false;
      this.findList();
    },
    toPayment(formData, payOnlineItem) {
      const rLoading = this.openLoading();
      let isBank = !formData;
      let notPayOnline = !payOnlineItem;
      this.ModelPayConfirm = false;
      if (!notPayOnline) {
        this.ModelPayOnline = true;
        this.$nextTick(() => {
          this.$refs.PayOnlineRef.getShow(1, payOnlineItem);
        });
      } else {
        if (isBank) {
          this.$refs.paymentBank.show(true);
        } else {
          this.verifyPayee2(formData);
        }
      }
      rLoading.close();
    }
  }
};
</script>
<style lang="scss">
.remarks {
  color: #d01415;
  font-size: 10px;
  margin-bottom: 10px;
}
</style>
